import { render, staticRenderFns } from "./VerticalDetailed.vue?vue&type=template&id=1b7c407f&scoped=true"
import script from "./VerticalDetailed.vue?vue&type=script&lang=js"
export * from "./VerticalDetailed.vue?vue&type=script&lang=js"
import style0 from "./VerticalDetailed.vue?vue&type=style&index=0&id=1b7c407f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c407f",
  null
  
)

export default component.exports